<template>
  <div v-if="loaded">
    <Mail
      :emails_list="courrier.emails"
      :attached_objects="[
        {
         object: 'DebiteurCourrier',
         id: courrier_id
        }
      ]"
      :body="body"
      :subject="subject"
      @close="$emit('close', $event)"
    >
    </Mail>
  </div>
</template>

<script>
import courriers from "@/services/courriers";
import Mail from "@/components/Mail.vue";
export default {
  name: "CourrierMail",
  components: {
    Mail,
  },
  props: {
    courrier_id: [Number, String],
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      courrier: {},
      body: '',
      loaded: false,
      subject: ''
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      courriers
        .get(this.$props.courrier_id)
        .then((response) => {
          this.courrier = response.data;
          this.subject = "Ref: " + this.courrier.mandatID.value
          if(this.courrier.nom.value.substr(0,6) == 'RAPPEL') {
            this.subject = "Rappel. " + this.subject;
          }
          this.loaded = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>